/**
 * Addon configuration data for ShopNest
 * Each addon has pricing for different durations
 */

export const ADDONS = [
  {
    id: 1,
    addon_type_id: 1,
    name: "Additional User",
    description:
      "Give your team the access they need to work smarter together.",
    is_onetime: true,
    unit: "User",
    prices: 50000,
    features: [
      "Lifetime user slot",
      "Reassign anytime as your team changes",
      "Multi-branch assignment",
      "Smooth team collaboration",
    ],
  },
  {
    id: 2,
    addon_type_id: 2,
    name: "Permission for features",
    description: "Control access to specific features for your team members.",
    is_onetime: false,
    unit: "Month",
    prices: {
      price_week: 10000,
      price_1month: 15000,
      price_3month: 45000,
      price_6month: 90000,
      price_12month: 180000,
      onetime_price: 0,
    },
    features: [
      "Custom permission levels",
      "Feature-based access control",
      "Role management",
    ],
  },
  {
    id: 3,
    addon_type_id: 3,
    name: "Multiple Branch Control",
    description: "Manage multiple locations from a single dashboard.",
    is_onetime: true,
    unit: "Location",
    prices: {
      price_week: 0,
      price_1month: 0,
      price_3month: 0,
      price_6month: 0,
      price_12month: 0,
      onetime_price: 250000,
    },
    features: [
      "Centralized management",
      "Branch-specific analytics",
      "Unified reporting",
    ],
  },
  {
    id: 4,
    addon_type_id: 4,
    name: "Search optimization",
    description: "Improve your online visibility and reach more customers.",
    is_onetime: false,
    unit: "Month",
    prices: {
      price_week: 0,
      price_1month: 0,
      price_3month: 45000,
      price_6month: 90000,
      price_12month: 180000,
      onetime_price: 0,
    },
    features: [
      "SEO optimization",
      "Local search visibility",
      "Keyword targeting",
    ],
  },
  {
    id: 5,
    addon_type_id: 5,
    name: "Stamps Exchange System",
    description: "Loyalty program where customers earn stamps for rewards.",
    is_onetime: false,
    unit: "Month",
    prices: {
      price_week: 0,
      price_1month: 0,
      price_3month: 30000,
      price_6month: 60000,
      price_12month: 120000,
      onetime_price: 0,
    },
    features: [
      "Digital stamp cards",
      "Automatic reward tracking",
      "Customer engagement",
    ],
  },
  {
    id: 6,
    addon_type_id: 6,
    name: "Points Exchange System",
    description: "Points-based loyalty system for your customers.",
    is_onetime: false,
    unit: "Month",
    prices: {
      price_week: 0,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 60000,
      price_12month: 120000,
      onetime_price: 0,
    },
    features: [
      "Flexible points earning",
      "Custom redemption options",
      "Points expiry management",
    ],
  },
  {
    id: 7,
    addon_type_id: 7,
    name: "Customized design for Stamps/Points Design",
    description: "Custom design for your loyalty program stamps and points.",
    is_onetime: true,
    unit: "Design",
    prices: {
      price_week: 0,
      price_1month: 0,
      price_3month: 0,
      price_6month: 0,
      price_12month: 0,
      onetime_price: 20000,
    },
    features: [
      "Custom stamp design",
      "Branded loyalty cards",
      "Unique visual identity",
    ],
  },
  {
    id: 8,
    addon_type_id: 8,
    name: "Gift Card",
    description: "Digital gift cards for your customers.",
    is_onetime: false,
    unit: "Transaction",
    prices: {
      price_week: 0,
      price_1month: 0,
      price_3month: 0,
      price_6month: 0,
      price_12month: 0,
      onetime_price: 0,
    },
    features: [
      "Digital gift cards",
      "Balance tracking",
      "Gift card sales reports",
    ],
  },
  {
    id: 9,
    addon_type_id: 9,
    name: "Customized design for Gift Card & high value loyalty cards",
    description:
      "Professional design for gift cards and premium loyalty cards.",
    is_onetime: true,
    unit: "Design",
    prices: {
      price_week: 0,
      price_1month: 0,
      price_3month: 0,
      price_6month: 0,
      price_12month: 0,
      onetime_price: 20000,
    },
    features: [
      "Custom gift card design",
      "Premium loyalty card design",
      "Brand-consistent visuals",
    ],
  },
  {
    id: 10,
    addon_type_id: 10,
    name: "Social Media Engagement (Content Creation) Package A",
    description: "Professional content creation for your social media.",
    is_onetime: false,
    unit: "Month",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: ["Weekly posts", "Social media management", "Content strategy"],
  },
  {
    id: 11,
    addon_type_id: 11,
    name: "Social Media Engagement (Content Creation) Package B",
    description: "Enhanced social media engagement package.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: ["Daily content", "Story creation", "Engagement monitoring"],
  },
  {
    id: 12,
    addon_type_id: 12,
    name: "Social Media Engagement (Content Creation Flex plan) Package C",
    description: "Flexible social media content creation plan.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: [
      "Flexible posting schedule",
      "Custom content calendar",
      "Performance analytics",
    ],
  },
  {
    id: 13,
    addon_type_id: 13,
    name: "Order",
    description: "Order management system for your business.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: ["Order tracking", "Inventory management", "Order analytics"],
  },
  {
    id: 14,
    addon_type_id: 14,
    name: "Reservations",
    description: "Table/reservation management system.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: [
      "Online reservations",
      "Table management",
      "Booking confirmations",
    ],
  },
  {
    id: 15,
    addon_type_id: 15,
    name: "Customer management",
    description: "Comprehensive customer relationship management.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: [
      "Customer database",
      "Purchase history",
      "Customer segmentation",
    ],
  },
  {
    id: 16,
    addon_type_id: 16,
    name: "Analytical dashboard",
    description: "Business intelligence and analytics dashboard.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: ["Real-time analytics", "Sales reports", "Business insights"],
  },
  {
    id: 17,
    addon_type_id: 17,
    name: "Interactive Advertisement",
    description: "Interactive advertising solutions for your business.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: [
      "Interactive ads",
      "Campaign management",
      "Ad performance tracking",
    ],
  },
  {
    id: 18,
    addon_type_id: 18,
    name: "Customized Menu QR (Hard Print)",
    description: "Custom designed QR code menus with professional printing.",
    is_onetime: false,
    unit: "Days",
    prices: {
      price_week: 5000,
      price_1month: 10000,
      price_3month: 30000,
      price_6month: 50000,
      price_12month: 100000,
      onetime_price: 0,
    },
    features: [
      "Custom QR code design",
      "Hard copy printing",
      "Digital menu management",
    ],
  },
];

/**
 * Get addon by type ID
 * @param {number} addonTypeId - The addon_type_id
 * @returns {object|undefined} The addon object
 */
export const getAddonByTypeId = (addonTypeId) => {
  return ADDONS.find((addon) => addon.addon_type_id === addonTypeId);
};

/**
 * Get addon by ID
 * @param {number} id - The addon ID
 * @returns {object|undefined} The addon object
 */
export const getAddonById = (id) => {
  return ADDONS.find((addon) => addon.id === id);
};

/**
 * Get available duration options for an addon
 * UI shows years but backend receives months
 * @param {object} addon - The addon object
 * @returns {array} Array of duration options with labels in years
 */
export const getDurationOptions = (addon) => {
  if (!addon) return [];

  const options = [];

  // Duration mapping: UI label vs backend month value
  const durationMap = [
    { uiValue: 3, label: "3 Months", backendValue: 3 },
    { uiValue: 6, label: "6 Months", backendValue: 6 },
    { uiValue: 12, label: "1 Year", backendValue: 12 },
    { uiValue: 24, label: "2 Years", backendValue: 24 },
    { uiValue: 36, label: "3 Years", backendValue: 36 },
  ];

  durationMap.forEach((duration) => {
    let price = 0;

    switch (duration.uiValue) {
      case 3:
        price = addon.prices.price_3month;
        break;
      case 6:
        price = addon.prices.price_6month;
        break;
      case 12:
        price = addon.prices.price_12month;
        break;
      case 24:
        // Calculate 2 years: 12 month price * 2
        price = addon.prices.price_12month * 2;
        break;
      case 36:
        // Calculate 3 years: 12 month price * 3
        price = addon.prices.price_12month * 3;
        break;
      default:
        price = 0;
    }

    if (price > 0) {
      options.push({
        uiValue: duration.uiValue,
        label: duration.label,
        backendValue: duration.backendValue,
        price: price,
      });
    }
  });

  return options;
};
